var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_6c2f35f0"]},_vm.$listeners),[_c('div',{class:["toast-with-mask-demo"]},[_c('cube-button',{on:{"_click":_vm.clickToast}},[_vm._v("Toast - with mask")]),_c('cube-toast',{ref:"__mpx_ref_toast__",attrs:{"txt":"遮罩层","mask":(true),"maskFadeTransition":(true)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }